export default __webpack_public_path__ + "static/media/success.e73df325.svg";